import { Component, OnInit, ElementRef, HostListener, inject } from '@angular/core';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { MdlManageContact } from '../../components/mdl-manage-contact/mdl-manage-contact';
import { MdlSelectCompanyType } from '../../components/mdl-public-private/mdl-public-private';
import { MdlManageOportunity } from '../../components/mdl-manage-opportunity/mdl-manage-opportunity';
import { PermissionService } from '../../services/permission.service';
import { MdlFilterOpportunities } from '../../components/mdl-filter-opportunities/mdl-filter-opportunities';

@Component({
    selector: 'app-opportunities',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './opportunities.html',
    styleUrls: ['./opportunities.css']
})
export class Opportunities implements OnInit {
    
    oportunidades: any[] = [];
    oportunidadesFiltradas: any[] = [];
    isLoading: boolean = true;
    errorMessage: string = '';
    showRecentDropdown: boolean = false;
    selectedItem: string = 'todas';
    openedMenuId: string | null = null;
    searchTerm: string = '';
    sortColumn: string = '';
    sortDirection: 'asc' | 'desc' = 'asc';
    activeFilters: any = null;
    ejecutivos: any[]=[]
    
    constructor(
        private api: Api,
        private elementRef: ElementRef,
        private router: Router,
        private alertService: AlertService,
        public permissionService: PermissionService
    ){
        this.cargarOportunidades();
    }

    readonly dialog = inject(MatDialog);

    ngOnInit(): void {
        this.cargarOportunidades();
        this.initializeFilters();

        const token = localStorage.getItem('crmtoken');
        const roleName = token ? (JSON.parse(atob(token.split('.')[1]))?.roleName || '') : '';
        if (roleName.toLowerCase() === 'admin' || roleName.toLowerCase() === 'administrador') {
        this.getEjecutivos();
        }

    }


    private initializeFilters(): void {
        if (!this.activeFilters) {
            this.activeFilters = {
                allStages: true,
                allTypes: true,
                allProbabilities: true,
                amountRange: 'all',
                closingDateRange: 'all',
                ejecutivoId: 'all',
                stages: {
                    prospeccion: false,
                    calificacion: false,
                    propuesta: false,
                    negociacion: false,
                    cerradaGanada: false,
                    cerradaPerdida: false
                },
                types: {
                    nuevoNegocio: false,
                    negocioExistente: false,
                    renovacion: false
                },
                probabilities: {
                    baja: false,
                    media: false,
                    alta: false
                }
            };
        }
    }

    openFilterModal(): void {
        const dialogRef = this.dialog.open(MdlFilterOpportunities, {
            minWidth: '600px',
            maxHeight: '80vh',
            panelClass: 'mat-dlg-class',
            data: { filters: this.activeFilters, ejecutivos: this.ejecutivos }
        });

        dialogRef.afterClosed().subscribe((filters: any) => {
            if (filters) {
                this.activeFilters = filters;
                this.applyAdvancedFilters();
                this.alertService.success('Filtros aplicados', 'Filtros aplicados correctamente');
            }
        });
    }

    private applyAdvancedFilters(): void {
        let filteredOpportunities = [...this.oportunidades];

        
        if (!this.activeFilters.allStages) {
            const selectedStages = Object.keys(this.activeFilters.stages).filter(key => this.activeFilters.stages[key]);
            if (selectedStages.length > 0) {
                filteredOpportunities = filteredOpportunities.filter(oportunidad => {
                    const opportunityStage = this.mapStageToFilter(oportunidad.etapa);
                    return selectedStages.includes(opportunityStage);
                });
            }
        }

        
        if (!this.activeFilters.allTypes) {
            const selectedTypes = Object.keys(this.activeFilters.types).filter(key => this.activeFilters.types[key]);
            if (selectedTypes.length > 0) {
                filteredOpportunities = filteredOpportunities.filter(oportunidad => {
                    const opportunityType = this.mapTypeToFilter(oportunidad.tipo_negocio);
                    return selectedTypes.includes(opportunityType);
                });
            }
        }

        
        if (!this.activeFilters.allProbabilities) {
            const selectedProbabilities = Object.keys(this.activeFilters.probabilities).filter(key => this.activeFilters.probabilities[key]);
            if (selectedProbabilities.length > 0) {
                filteredOpportunities = filteredOpportunities.filter(oportunidad => {
                    const probability = this.getProbabilityRange(oportunidad.probabilidad_cierre);
                    return selectedProbabilities.includes(probability);
                });
            }
        }

        if (this.activeFilters.amountRange !== 'all') {
            filteredOpportunities = this.filterByAmountRange(filteredOpportunities, this.activeFilters.amountRange);
        }

        if (this.activeFilters.closingDateRange !== 'all') {
            filteredOpportunities = this.filterByClosingDateRange(filteredOpportunities, this.activeFilters.closingDateRange);
        }

        
        if (this.activeFilters.ejecutivoId && this.activeFilters.ejecutivoId !== 'all') {
            filteredOpportunities = filteredOpportunities.filter(o =>
              o.contacto?.ejecutivo?.usuario_id === this.activeFilters.ejecutivoId
            );
          }
       

        this.oportunidadesFiltradas = filteredOpportunities;
        
        if (this.sortColumn) {
            this.applySorting();
        }
   
    }

    private mapStageToFilter(etapa: string): string {
        const stageMap: { [key: string]: string } = {
            'prospección': 'prospeccion',
            'prospeccion': 'prospeccion',
            'calificación': 'calificacion',
            'calificacion': 'calificacion',
            'propuesta': 'propuesta',
            'negociación': 'negociacion',
            'negociacion': 'negociacion',
            'cerrada ganada': 'cerradaGanada',
            'cerradaganada': 'cerradaGanada',
            'cerrada perdida': 'cerradaPerdida',
            'cerradaperdida': 'cerradaPerdida'
        };
        
        return stageMap[etapa?.toLowerCase()] || etapa?.toLowerCase();
    }

    private mapTypeToFilter(tipo: string): string {
        const typeMap: { [key: string]: string } = {
            'nuevo negocio': 'nuevoNegocio',
            'nuevo': 'nuevoNegocio',
            'negocio existente': 'negocioExistente',
            'existente': 'negocioExistente',
            'renovación': 'renovacion',
            'renovacion': 'renovacion'
        };
        
        return typeMap[tipo?.toLowerCase()] || tipo?.toLowerCase();
    }

    private getProbabilityRange(probabilidad: number): string {
        if (probabilidad <= 33) return 'baja';
        if (probabilidad <= 66) return 'media';
        return 'alta';
    }

    private filterByAmountRange(opportunities: any[], amountRange: string): any[] {
        return opportunities.filter(oportunidad => {
            const amount = parseFloat(oportunidad.importe_actual) || 0;
            
            switch (amountRange) {
                case '0-1000000':
                    return amount >= 0 && amount <= 1000000;
                case '1000001-5000000':
                    return amount >= 1000001 && amount <= 5000000;
                case '5000001-10000000':
                    return amount >= 5000001 && amount <= 10000000;
                case '10000001+':
                    return amount > 10000000;
                default:
                    return true;
            }
        });
    }

    private filterByClosingDateRange(opportunities: any[], closingDateRange: string): any[] {
        const hoy = new Date();
        
        switch (closingDateRange) {
            case '7d':
                const sieteDiasAdelante = new Date(hoy);
                sieteDiasAdelante.setDate(hoy.getDate() + 7);
                return opportunities.filter(oportunidad => {
                    if (!oportunidad.fecha_cierre_estimada) return false;
                    const fechaCierre = new Date(oportunidad.fecha_cierre_estimada);
                    return fechaCierre <= sieteDiasAdelante && fechaCierre >= hoy;
                });
            
            case '30d':
                const treintaDiasAdelante = new Date(hoy);
                treintaDiasAdelante.setDate(hoy.getDate() + 30);
                return opportunities.filter(oportunidad => {
                    if (!oportunidad.fecha_cierre_estimada) return false;
                    const fechaCierre = new Date(oportunidad.fecha_cierre_estimada);
                    return fechaCierre <= treintaDiasAdelante && fechaCierre >= hoy;
                });
            
            case 'pasadas':
                return opportunities.filter(oportunidad => {
                    if (!oportunidad.fecha_cierre_estimada) return false;
                    const fechaCierre = new Date(oportunidad.fecha_cierre_estimada);
                    return fechaCierre < hoy;
                });
            
            default:
                return opportunities;
        }
    }

    sortByColumn(column: string): void {
        if (this.sortColumn === column) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortColumn = column;
            this.sortDirection = 'asc';
        }

        this.applySorting();
    }

    private applySorting(): void {
        if (!this.sortColumn) return;

        this.oportunidadesFiltradas = [...this.oportunidadesFiltradas].sort((a, b) => {
            let valueA = a[this.sortColumn];
            let valueB = b[this.sortColumn];

            switch (this.sortColumn) {
                case 'nombre':
                    valueA = valueA?.toLowerCase() || '';
                    valueB = valueB?.toLowerCase() || '';
                    break;
                
                case 'cuenta.nombre_empresa':
                    valueA = a.cuenta?.nombre_empresa?.toLowerCase() || '';
                    valueB = b.cuenta?.nombre_empresa?.toLowerCase() || '';
                    break;
                
                case 'importe_actual':
                    valueA = parseFloat(valueA) || 0;
                    valueB = parseFloat(valueB) || 0;
                    break;
                
                case 'fecha_cierre_estimada':
                    valueA = valueA ? new Date(valueA) : new Date(0);
                    valueB = valueB ? new Date(valueB) : new Date(0);
                    break;
                
                case 'etapa':
                    const stagePriorityA = this.getStagePriority(valueA);
                    const stagePriorityB = this.getStagePriority(valueB);
                    return this.sortDirection === 'asc' ? stagePriorityA - stagePriorityB : stagePriorityB - stagePriorityA;
                
                case 'probabilidad_cierre':
                    valueA = parseFloat(valueA) || 0;
                    valueB = parseFloat(valueB) || 0;
                    break;
                
                case 'tipo_negocio':
                    valueA = valueA?.toLowerCase() || '';
                    valueB = valueB?.toLowerCase() || '';
                    break;
                
                case 'contacto.ejecutivo.nombre':
                    valueA = `${a.contacto?.ejecutivo?.nombre || ''} ${a.contacto?.ejecutivo?.apellido || ''}`.toLowerCase();
                    valueB = `${b.contacto?.ejecutivo?.nombre || ''} ${b.contacto?.ejecutivo?.apellido || ''}`.toLowerCase();
                    break;
                
                case 'importe_total_contrato':
                    valueA = parseFloat(valueA) || 0;
                    valueB = parseFloat(valueB) || 0;
                    break;

                
                default:
                    if (typeof valueA === 'string') {
                        valueA = valueA.toLowerCase();
                        valueB = valueB.toLowerCase();
                    }
            }

            if (valueA < valueB) {
                return this.sortDirection === 'asc' ? -1 : 1;
            }
            if (valueA > valueB) {
                return this.sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });
    }

    private getStagePriority(etapa: string): number {
        switch (etapa?.toLowerCase()) {
            case 'cerrada ganada':
                return 6;
            case 'cerrada perdida':
                return 5;
            case 'negociación':
            case 'negociacion':
                return 4;
            case 'propuesta':
                return 3;
            case 'calificación':
            case 'calificacion':
                return 2;
            case 'prospección':
            case 'prospeccion':
                return 1;
            default:
                return 0;
        }
    }

    onSearchChange(): void {
        if (!this.searchTerm.trim()) {
            if (this.activeFilters) {
                this.applyAdvancedFilters();
            } else {
                this.oportunidadesFiltradas = [...this.oportunidades];
            }
        } else {
            const searchLower = this.searchTerm.toLowerCase().trim();
            this.oportunidadesFiltradas = this.oportunidades.filter(oportunidad => 
                oportunidad.nombre?.toLowerCase().includes(searchLower) ||
                oportunidad.cuenta?.nombre_empresa?.toLowerCase().includes(searchLower) ||
                oportunidad.etapa?.toLowerCase().includes(searchLower) ||
                oportunidad.tipo_negocio?.toLowerCase().includes(searchLower) ||
                oportunidad.contacto?.ejecutivo?.nombre?.toLowerCase().includes(searchLower) ||
                oportunidad.contacto?.ejecutivo?.apellido?.toLowerCase().includes(searchLower) ||
                oportunidad.importe_actual?.toString().includes(searchLower) ||
                oportunidad.importe_total_contrato?.toString().includes(searchLower)

            );
        }
        
        if (this.sortColumn) {
            this.applySorting();
        }
    }

    hasActiveFilters(): boolean {
        if (!this.activeFilters) return false;
        const hasStageFilter = !this.activeFilters.allStages && 
            Object.values(this.activeFilters.stages).some(val => val === true);
        const hasTypeFilter = !this.activeFilters.allTypes && 
            Object.values(this.activeFilters.types).some(val => val === true);
        const hasProbabilityFilter = !this.activeFilters.allProbabilities && 
            Object.values(this.activeFilters.probabilities).some(val => val === true);
        const hasAmountFilter = this.activeFilters.amountRange !== 'all';
        const hasDateFilter = this.activeFilters.closingDateRange !== 'all';
        
        return hasStageFilter || hasTypeFilter || hasProbabilityFilter || hasAmountFilter || hasDateFilter;
    }

    clearFilters(): void {
        this.activeFilters = null;
        this.searchTerm = '';
        this.sortColumn = '';
        this.sortDirection = 'asc';
        this.initializeFilters();
        this.oportunidadesFiltradas = [...this.oportunidades];
        this.alertService.success('Filtros limpiados', 'Los filtros han sido limpiados');
    }


    cargarOportunidades(): void {
        this.api.showLoading();
        this.isLoading = true;
        this.errorMessage = '';      

        this.api.getOpportunities().subscribe({
            next: (response:any)=>{
                this.oportunidades = (response.oportunidades || response).map((oportunidad:any)=>({
                    ...oportunidad,
                    id: oportunidad.oportunidad_id || oportunidad.id,
                    propietarioId: oportunidad.ejecutivo_id     
                }));

                if (this.activeFilters) {
                    this.applyAdvancedFilters();
                } else {
                    this.oportunidadesFiltradas = [...this.oportunidades];
                }

                setTimeout(() => {
                    this.api.hideLoading();
                    this.isLoading = false;
                }, 500);
            },
            error: (error: any) => {
                console.error('Error al cargar prospectos:', error);

                if (error.status === 403) {
                    this.errorMessage = 'No tienes permiso para ver oportunidades.';
                } else {
                    this.errorMessage = 'Error al cargar la lista de oportunidades.';
                }

                setTimeout(() => {
                    this.api.hideLoading();
                    this.isLoading = false;
                }, 500);
            }
        });
    }


    private esUUIDValido(id: string): boolean {
        const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regex.test(id);
    }

    mostrarMensaje(mensaje: string, tipo: 'exito' | 'error' | 'advertencia'): void {
        switch (tipo) {
            case 'exito':
                this.alertService.success('Éxito', mensaje);
                break;
            case 'error':
                this.alertService.error('Error', mensaje);
                break;
            case 'advertencia':
                this.alertService.warning('Advertencia', mensaje);
                break;
        }
    }

    toggleRecentDropdown(): void {
        this.showRecentDropdown = !this.showRecentDropdown;
    }

    selectItem(key: string): void {
        this.selectedItem = key;
        this.showRecentDropdown = false; 
    }

    toggleActionsMenu(id: string): void {
        this.openedMenuId = this.openedMenuId === id ? null : id;
        this.showRecentDropdown = false; 
    }

    openMdlCreateOportunity(): void {
        this.dialog.open(MdlSelectCompanyType,{
            minWidth: '800px',
            maxHeight: '900px',
            panelClass: 'mat-dlg-class',
            data:{
                mode: 'create'
            }
        });
    }

    openMdlDeleteOportunity(id:string): void {
        const dialogRef = this.dialog.open(MdlDelete, {
            minWidth: '400px',
            maxHeight: '600px',
            panelClass: 'mat-dlg-class',
            data: {
                mode: 'oportunity',
                id: id
            }
        }).afterClosed().subscribe(result => {
            if (result) {
                this.oportunidades = this.oportunidades.filter(opportunity => opportunity.id !== id);
                this.cargarOportunidades()
                this.mostrarMensaje('Oportunidad eliminada exitosamente.', 'exito');
            }


        });
    }

    verDetalleOportunidad(id: string, event?: MouseEvent) :void {
        if (event){
            const target = event.target as HTMLElement;
            const isCheckbox = target.tagName === 'INPUT' && target.getAttribute('type') === 'checkbox';
            const isDropdown = target.closest('.dropdown-container') !== null;

            if (isCheckbox || isDropdown){
                return;
            }
        }

        if (!id || !this.esUUIDValido(id)){
            this.mostrarMensaje('ID de Oportunidad no valido', 'error');
            return
        }

        this.router.navigate(['opportunity', id]).then(navigationResult => {
            if (!navigationResult){
                this.mostrarMensaje('No se pudo cargar el detalle de la oportunidad','error');
                console.error('Error de navegacion a Oportunities', id)
            }
        });
    }

    updateOportunity(data: any) {
        console.log("Click");
        this.dialog.open(MdlManageOportunity,{
            minWidth: '800px',
            maxHeight: '900px',
            panelClass: 'mat-dlg-class',
            data:{
                mode: 'edit',
                oportunidad: data
            }
        });
    }

    goOpportunitiesGeneral(){
        this.router.navigate(['/opportunities-generalview'])
    }

    @HostListener('document:click', ['$event.target'])
    onClickOutside(target: EventTarget | null): void {
        if (!(target instanceof HTMLElement)) return;
        
        const clickedInsideRecent = this.elementRef.nativeElement.querySelector('.dropdown-trigger')?.contains(target);
        const clickedInsideActions = this.elementRef.nativeElement.querySelector('.dots-button')?.contains(target);
        
        if (!clickedInsideRecent) {
            this.showRecentDropdown = false;
        }
        
        if (!clickedInsideActions) {
            this.openedMenuId = null;
        }
    }

    getEjecutivos(): void {
        this.api.getUsers().subscribe({
          next: (res: any) => {
            this.ejecutivos = (res.users || []).map((u: any) => ({
              usuario_id: u.usuario_id,
              nombreCompleto: `${u.nombre} ${u.apellido}`.trim()
            }));
          },
          error: (err: any) => console.error('Error al cargar ejecutivos:', err),
        });
      }
      
}